import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type TranslationKeys = {
    first_title_key: string
    first_desc_key: string
    second_title_key: string
    second_desc_key: string
    third_title_key: string
    third_desc_key: string
}

interface IGuideSteps {
    translation_keys: TranslationKeys
}

const GuideSteps: FC<IGuideSteps> = ({ translation_keys }) => {
  return (
    <div className='guide_steps'>
        <FormattedMessage
            tagName='h2'
            id='how_it_works_title'
        />
        <div className='d-flex gap-3 mt-5 flex-column align-items-center align-items-md-start flex-md-row walkthrough'>
            <div className='info_step'>
            <div className='d-flex align-items-center justify-content-start'>
                <FormattedMessage
                    tagName='h2'
                    id={translation_keys.first_title_key}
                />
            </div>
            <FormattedMessage
                tagName='p'
                id={translation_keys.first_desc_key}
            />
            </div>
            <div className='next_arrow for_brand_color_line d-none d-md-block mt-3'></div>
            <div className='next_arrow for_brand_color_line mobile d-block d-md-none'></div>
            <div className='info_step'>
            <div className='d-flex align-items-center justify-content-start'>
                <FormattedMessage
                    tagName='h2'
                    id={translation_keys.second_title_key}
                />
            </div>
            <FormattedMessage
                tagName='p'
                id={translation_keys.second_desc_key}
            />
            </div>
            <div className='next_arrow for_brand_color_line d-none d-md-block mt-3'></div>
            <div className='next_arrow for_brand_color_line mobile d-block d-md-none'></div>
            <div className='info_step'>
            <div className='d-flex align-items-center justify-content-start'>
                <FormattedMessage
                    tagName='h2'
                    id={translation_keys.third_title_key}
                />
            </div>
            <FormattedMessage
                tagName='p'
                id={translation_keys.third_desc_key}
            />
            </div>
        </div>
    </div>
  )
}

export default GuideSteps
